import mockMusicLinkUrlPartsData from "../../data/mockData/musicLinkUrlPartsData";
import { types } from "./action";

const initialState = {
  seed: mockMusicLinkUrlPartsData,
  tableRowResults: [],
  created: [],
};

function upsertById(rows, row) {
  if (!row || row.id == null) {
    return rows;
  }
  const sid = String(row.id);
  const idx = rows.findIndex(r => String(r.id) === sid);
  if (idx >= 0) {
    const next = [...rows];
    next[idx] = { ...next[idx], ...row };
    return next;
  }
  return [...rows, row];
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_MUSIC_LINK_URL_PARTS:
      return {
        ...state,
        tableRowResults: Array.isArray(action.payload) ? action.payload : state.tableRowResults,
      };
    case types.ADD_MUSIC_LINK_URL_PART: {
      const row = action.payload;
      if (!row || row.id == null) {
        return state;
      }
      const exists = state.created.some(r => String(r.id) === String(row.id));
      if (exists) {
        return state;
      }
      return {
        ...state,
        created: [...state.created, row],
      };
    }
    case types.UPDATE_MUSIC_LINK_URL_PART: {
      const row = action.payload;
      if (!row || row.id == null) {
        return state;
      }
      return {
        ...state,
        created: upsertById(state.created, row),
      };
    }
    case types.DELETE_MUSIC_LINK_URL_PART: {
      const id = action.payload;
      if (id == null) {
        return state;
      }
      const sid = String(id);
      return {
        ...state,
        tableRowResults: state.tableRowResults.filter(row => String(row?.id) !== sid),
        created: state.created.filter(row => String(row?.id) !== sid),
      };
    }
    default:
      return state;
  }
};
